import { useEffect, useState } from "react";
import { api, cardImageUrl } from "@/lib/api";
import { Layers, Package, Boxes, Shield } from "lucide-react";

const TYPES = [
  { key: "card", label: "Carta suelta", hint: "Se busca en el catálogo", Icon: Layers },
  { key: "sealed", label: "Sellado", hint: "Catálogo de sellados o producto nuevo", Icon: Package },
  { key: "lot", label: "Lote", hint: "Bulk, deck o colección", Icon: Boxes },
  { key: "accessory", label: "Accesorios", hint: "Solo productos sellados", Icon: Shield },
];

const Recent = ({ onAgain }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/seller/recent-publications").then((r) => setRows(r.data || [])).catch(() => {}); }, []);
  if (!rows.length) return null;
  return (
    <div className="mt-4" data-testid="p1-recent">
      <div className="text-[10px] uppercase tracking-wider text-neutral-500 mb-2">Publicar otra igual</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {rows.map((p) => (
          <div key={p.id} className="flex items-center gap-3 p-2.5 rounded-[14px] border border-[#262626] bg-[#0A0A0A]" data-testid={`p1-recent-${p.id}`}>
            <div className="w-9 h-12 rounded bg-black overflow-hidden shrink-0">
              {p.card.image_url && <img src={cardImageUrl(p.card.image_url, 200)} alt="" className="w-full h-full object-contain" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-white truncate">{p.card.name}</div>
              <div className="text-[11px] text-neutral-500">{p.condition} · ${Number(p.price).toFixed(2)}</div>
            </div>
            <button type="button" onClick={() => onAgain(p)} className="h-8 px-3 rounded-full border border-[#FF4438] text-[#FF6B5E] text-xs font-bold" data-testid={`p1-again-${p.id}`}>+ Otra</button>
          </div>
        ))}
      </div>
    </div>
  );
};

// P1 · Inicio: 4 tipos, aviso verde y "Publicar otra igual".
export const P1Start = ({ active, onType, onAgain }) => (
  <div className="mb-5" data-testid="p1-start">
    <div className="grid grid-cols-2 gap-2 sm:gap-3">
      {TYPES.map(({ key, label, hint, Icon }) => (
        <button key={key} type="button" onClick={() => onType(key)} data-testid={`p1-type-${key}`}
          className={`p-3 sm:p-4 rounded-[16px] border-2 text-left transition-colors ${active === key ? "border-[#FF4438] bg-[#FF4438]/10" : "border-[#262626] bg-[#111] hover:border-neutral-600"}`}>
          <Icon size={18} className={active === key ? "text-[#FF6B5E]" : "text-neutral-400"} />
          <div className="font-display text-sm sm:text-lg text-white mt-1.5 leading-tight">{label}</div>
          <div className="text-[10px] sm:text-[11px] text-neutral-500 mt-0.5 leading-tight">{hint}</div>
        </button>
      ))}
    </div>
    <div className="mt-3 p-3 rounded-[14px] border border-emerald-500/40 bg-emerald-500/5 text-xs text-emerald-200" data-testid="p1-notice">
      No tienes que registrar nada. Si la carta está en el catálogo, la eliges y se publica al instante.
    </div>
    <Recent onAgain={onAgain} />
  </div>
);
